import { memo } from "react";

const rowStyle = { display: "flex", justifyContent: "space-between" };

export const PaymentInformationSection = memo(
  function PaymentInformationSection({
    cardInfo,
    total,
  }: {
    cardInfo: string;
    total: string;
  }) {
    return (
      <div style={rowStyle}>
        <div>{cardInfo}</div>
        <div>{`${total}`}</div>
      </div>
    );
  },
);
